export const DELETE_REPORT_REQUEST = 'DELETE_REPORT_REQUEST';

export const deleteReportRequest = ( id ) => ({
    type: DELETE_REPORT_REQUEST,
    payload: { id }
});
